export default "__VITE_ASSET__DXBv1wXg__"